import { breakpoints } from '@hm-group/fabric-tokens'; // TODO: Use default imports from @hm-group/fabric-tokens
/**
 * Return srcset sizes based on styleguide breakpoints.
 *
 * @param object - An object includes sizes.
 * @param object.baseVw - The base size with vm.
 * @param object.xsmall - The xsmall size that is optional.
 * @param object.small - The small size that is optional.
 * @param object.medium - The medium size that is optional.
 * @param object.large - The large size that is optional.
 * @param object.xlarge - The xlarge size that is optional.
 * @param object.shouldAppendImageSizeWithVw - The image size appended with vm.
 * @returns - Return the viewwidth string using breakpoint sizes.
 */
const getImageSrcSetSizes = ({ baseVw, xsmall, small, medium, large, xlarge, shouldAppendImageSizeWithVw = true, }) => {
    let sizesAttr = '';
    const sizesFactory = (breakpoint, imageSize) => `${sizesAttr}${sizesAttr && ', '}${breakpoint ? `(max-width: ${breakpoint}px) ` : ''}${imageSize}${shouldAppendImageSizeWithVw ? 'vw' : ''}`;
    if (xsmall) {
        sizesAttr = sizesFactory(breakpoints.xsmall, xsmall);
    }
    if (small) {
        sizesAttr = sizesFactory(breakpoints.small, small);
    }
    if (medium) {
        sizesAttr = sizesFactory(breakpoints.medium, medium);
    }
    if (large) {
        sizesAttr = sizesFactory(breakpoints.large, large);
    }
    if (xlarge) {
        sizesAttr = sizesFactory(breakpoints.xlarge, xlarge);
    }
    if (baseVw) {
        sizesAttr = sizesFactory('', baseVw);
    }
    return sizesAttr;
};
export default getImageSrcSetSizes;
//# sourceMappingURL=getImageSrcSetSizes.js.map